import { render, staticRenderFns } from "./vListEdit.vue?vue&type=template&id=b2e5f59c&scoped=true&"
import script from "./vListEdit.vue?vue&type=script&lang=js&"
export * from "./vListEdit.vue?vue&type=script&lang=js&"
import style0 from "./vListEdit.vue?vue&type=style&index=0&id=b2e5f59c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e5f59c",
  null
  
)

export default component.exports